import { LucideIcon } from 'lucide-react';
import React from 'react';

interface ServiceCardProps {
  title: string;
  description: string;
  Icon?: LucideIcon;
  renderedIcon?: React.ReactNode;
}

const ServiceCard = ({ title, description, Icon, renderedIcon }: ServiceCardProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100 te flex md:block">
      <div className="min-w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mb-4 mr-8 md: w-12">
        {Icon && <Icon className="text-red-600" size={24} />}
        {renderedIcon}
      </div>
      <div className={''}>
        <h3 className="text-lg font-semibold mb-2 ">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
